<div class="dashboard-container">
    <!-- Header Component -->
    <app-header
      [hasAccess]="hasAccess"
      [isEntityLocked]="isEntityLocked"
      [isHomePage]="isOnHomePage"
      (homeClicked)="onHomeClicked()"
    ></app-header>

    <!-- Main Content -->
    <main class="main-content">
        <router-outlet />
    </main>
</div>